export default __webpack_public_path__ + "static/media/KSM.1fcd2773.svg";